import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, inject, onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwiperItem',
  setup(__props) {

const swiperData: any = inject('swiper');
const swiperItemStyle = ref();

swiperData.addSwiperItem();

onMounted(() => {
  swiperItemStyle.value = {
    width: `${swiperData.swiperRef.value.offsetWidth}px`,
    height: `${swiperData.swiperRef.value.offsetHeight}px`,
  };
});

onUnmounted(() => {
  swiperData.removeSwiperItem();
});

return { __sfc: true,swiperData, swiperItemStyle }
}

})